export default {
  inject: ['assessmentSingleTask'],
  created() {
    const parent = this.assessmentSingleTask;
    if (!parent) {
      return;
    }

    const dataKeys = parent.$data ? Object.keys(parent.$data) : [];
    const methodKeys = parent.$options && parent.$options.methods ? Object.keys(parent.$options.methods) : [];
    const computedKeys = parent.$options && parent.$options.computed ? Object.keys(parent.$options.computed) : [];

    methodKeys.forEach((key) => {
      if (key in this) {
        return;
      }
      this[key] = parent[key].bind(parent);
    });

    const proxyKeys = [...new Set([...dataKeys, ...computedKeys])];
    proxyKeys.forEach((key) => {
      if (key in this) {
        return;
      }
      Object.defineProperty(this, key, {
        configurable: true,
        enumerable: true,
        get: () => parent[key],
        set: (value) => {
          parent[key] = value;
        }
      });
    });
  }
};
